import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UsaDigsTab } from './admin/AdminBidDetail';

// Full-screen USA (811) dig-ticket management for one job's workflow, reachable
// from the field/mobile Work Flows board so PMs and Field Supervisors can add
// tickets, log the call-in, attach the PDF, and take photos — not office-only.
const API_BASE = process.env.REACT_APP_API_BASE || 'https://app.titanelectricreno.com:8080/api';
function getToken() { try { return JSON.parse(localStorage.getItem('titan_session') || 'null')?.token; } catch { return null; } }

export default function UsaDigsScreen() {
  const { sjId } = useParams();
  const navigate = useNavigate();
  const [hdr, setHdr] = useState('');

  useEffect(() => {
    fetch(`${API_BASE}/workflows`, { headers: { 'x-worker-token': getToken() } })
      .then(r => (r.ok ? r.json() : []))
      .then(all => {
        const w = (Array.isArray(all) ? all : []).find(x => String(x.id) === String(sjId));
        if (w) setHdr(`${w.project_number ? w.project_number + ' · ' : ''}${(w.project_name || '').replace(/^\s*\S+\s*-\s*/, '')}`);
      })
      .catch(() => {});
  }, [sjId]);

  return (
    <div className="page" style={{ background: '#f7f7f7', minHeight: '100vh' }}>
      <div className="top-bar">
        <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', color: '#fff' }}>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M14 4l-7 7 7 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <div className="top-bar-wordmark" style={{ flex: 1, textAlign: 'center' }}>USA DIG TICKETS</div>
        <div style={{ width: 22 }} />
      </div>
      <div style={{ padding: '16px 16px 100px' }}>
        {hdr && <div style={{ fontSize: 18, fontWeight: 800, color: '#111', marginBottom: 14 }}>{hdr}</div>}
        <UsaDigsTab sjId={sjId} isAdminZone={true} API_BASE={API_BASE} getToken={getToken}
          showToast={(m, t) => { if (t === 'error' && m) window.alert(m); }} />
      </div>
    </div>
  );
}
